import tw from 'twin.macro';

const DateLabel = tw.div`text-xs text-gray-600`;

export default DateLabel;
